import React from "react";
import styles from "./PreviewV3.module.css";

export default function PreviewHeader({ swmsData }) {

  const sections = (swmsData && swmsData.sections) || {};
  const projectSection = sections.document_project_details || {};
  const projectDetails = projectSection.data || {};
  const orgDetails = projectDetails.org_details || {};
  const orgName = orgDetails.name || "";
  const orgLetter = orgName ? orgName.charAt(0) : "";
  const swmsNumber = projectDetails.swms_number || "";
  const swmsVersion = projectDetails.swms_version;
  const revNumber = (swmsVersion && swmsVersion.slice(1)) || "1";

  return (
    <div className={styles.PreviewDocBand} id="prv-doc-band">
      <div className={styles.PreviewDocBandLetter}>
        <div className={styles.PreviewDocBandMark}>{orgLetter}</div>
        <div>
          <div className={styles.PreviewDocBandName}>{orgName}</div>
          <div className={styles.PreviewDocBandSub}>Safe Work Method Statement</div>
        </div>
      </div>
      <div className={styles.PreviewDocBandRight}>
        <div className={styles.PreviewDocBandNo}>{swmsNumber}</div>
        <div>Rev {revNumber} &middot; Pending</div>
        <div>Controlled — Uncontrolled if Printed</div>
      </div>
    </div>
  )
}